export interface CardTheme {
  id: string;
  name: string;
  description: string;
  bgGradient: string;
  textColor: string;
  accentColor: string;
  borderColor: string;
  qrBg: string;
  qrFg: string;
  overlayOpacity: number;
  fontStyle: 'serif' | 'sans';
}

export const cardThemes: CardTheme[] = [
  {
    id: 'golden-bitcoin',
    name: 'Golden Bitcoin',
    description: 'A warm golden gradient with a luxurious feel',
    bgGradient: 'linear-gradient(135deg, #f6d365 0%, #fda085 50%, #f6d365 100%)',
    textColor: '#1a1a2e',
    accentColor: '#b8860b',
    borderColor: '#daa520',
    qrBg: '#ffffff',
    qrFg: '#1a1a2e',
    overlayOpacity: 0.15,
    fontStyle: 'serif',
  },
  {
    id: 'midnight-purple',
    name: 'Midnight Purple',
    description: 'Deep purple tones with ethereal glow',
    bgGradient: 'linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)',
    textColor: '#e8e0f0',
    accentColor: '#a78bfa',
    borderColor: '#7c3aed',
    qrBg: '#ffffff',
    qrFg: '#0f0c29',
    overlayOpacity: 0.2,
    fontStyle: 'sans',
  },
  {
    id: 'ocean-teal',
    name: 'Ocean Teal',
    description: 'Calm ocean blues and teals',
    bgGradient: 'linear-gradient(135deg, #0d9488 0%, #065f46 50%, #0d9488 100%)',
    textColor: '#ecfdf5',
    accentColor: '#34d399',
    borderColor: '#10b981',
    qrBg: '#ffffff',
    qrFg: '#064e3b',
    overlayOpacity: 0.15,
    fontStyle: 'sans',
  },
  {
    id: 'rose-garden',
    name: 'Rose Garden',
    description: 'Romantic pink and rose tones',
    bgGradient: 'linear-gradient(135deg, #fecdd3 0%, #fb7185 50%, #f43f5e 100%)',
    textColor: '#1c1917',
    accentColor: '#be123c',
    borderColor: '#e11d48',
    qrBg: '#ffffff',
    qrFg: '#1c1917',
    overlayOpacity: 0.12,
    fontStyle: 'serif',
  },
  {
    id: 'arctic-frost',
    name: 'Arctic Frost',
    description: 'Cool blues with frosty elegance',
    bgGradient: 'linear-gradient(135deg, #dbeafe 0%, #93c5fd 50%, #3b82f6 100%)',
    textColor: '#1e293b',
    accentColor: '#1d4ed8',
    borderColor: '#2563eb',
    qrBg: '#ffffff',
    qrFg: '#1e293b',
    overlayOpacity: 0.1,
    fontStyle: 'sans',
  },
  {
    id: 'emerald-night',
    name: 'Emerald Night',
    description: 'Rich emerald on dark background',
    bgGradient: 'linear-gradient(135deg, #022c22 0%, #064e3b 50%, #065f46 100%)',
    textColor: '#d1fae5',
    accentColor: '#6ee7b7',
    borderColor: '#34d399',
    qrBg: '#ffffff',
    qrFg: '#022c22',
    overlayOpacity: 0.2,
    fontStyle: 'serif',
  },
  {
    id: 'sunset-fire',
    name: 'Sunset Fire',
    description: 'Warm sunset oranges and reds',
    bgGradient: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 50%, #ff4500 100%)',
    textColor: '#fff7ed',
    accentColor: '#fbbf24',
    borderColor: '#f59e0b',
    qrBg: '#ffffff',
    qrFg: '#7c2d12',
    overlayOpacity: 0.15,
    fontStyle: 'sans',
  },
  {
    id: 'minimal-white',
    name: 'Minimal White',
    description: 'Clean and minimal white card',
    bgGradient: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 50%, #f1f5f9 100%)',
    textColor: '#0f172a',
    accentColor: '#64748b',
    borderColor: '#cbd5e1',
    qrBg: '#ffffff',
    qrFg: '#0f172a',
    overlayOpacity: 0.05,
    fontStyle: 'sans',
  },
];
